import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
export var defaultValues = {
    icons: {
        complete: faStar,
        half: faStarHalfAlt,
        empty: faStar,
    },
    max: 5,
    colors: ['#000', '#000', '#000'],
};
